const respondToMainCtaVisibility = function (element, callback) {
  const options = {
    rootMargin: '0px',
    threshold: 1,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      callback(entry.isIntersecting && entry.intersectionRatio >= 1);
    });
  }, options);

  observer.observe(element);
};

const toggleStickyCtaVisibility = (isMainCtaVisible) => {
  const stickyCtaContainer = document.querySelector('.sticky-cta-container');

  if (stickyCtaContainer !== null) {
    if (isMainCtaVisible) {
      stickyCtaContainer.classList.add('!tw-hidden');
    } else {
      stickyCtaContainer.classList.remove('!tw-hidden');
    }
  }
};

const initStickyButtonLoading = () => {
  const stickyButton = document.getElementById('ProductSubmitButton-Sticky');
  if (!stickyButton) return;

  let activeTimeoutId = null;
  let activeObserver = null;

  stickyButton.addEventListener('click', () => {
    if (stickyButton.getAttribute('aria-disabled') === 'true') return;

    // Clean up any previous loading cycle
    if (activeTimeoutId) clearTimeout(activeTimeoutId);
    if (activeObserver) activeObserver.disconnect();

    stickyButton.setAttribute('aria-disabled', 'true');
    stickyButton.classList.add('loading');
    const spinner = stickyButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const clearLoading = () => {
      if (activeTimeoutId) clearTimeout(activeTimeoutId);
      if (activeObserver) activeObserver.disconnect();
      activeTimeoutId = null;
      activeObserver = null;
      stickyButton.classList.remove('loading');
      stickyButton.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    };

    const formId = stickyButton.getAttribute('form');
    const mainForm = document.getElementById(formId);
    const mainButton = mainForm ? mainForm.querySelector('[type="submit"]') : null;

    if (mainButton) {
      activeObserver = new MutationObserver(() => {
        if (!mainButton.classList.contains('loading')) {
          clearLoading();
        }
      });
      activeObserver.observe(mainButton, { attributes: true, attributeFilter: ['class'] });
    }

    activeTimeoutId = setTimeout(clearLoading, 10000);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const mainCtaNode = document.querySelector('.jump-product-cta-visibility');

  if (mainCtaNode) {
    respondToMainCtaVisibility(mainCtaNode, toggleStickyCtaVisibility);
  }
  initStickyButtonLoading();
});
